<template>
    <div class="m-header"
         :style="{width:live.width + 'px', height: live.height + 'px'}">
        <div class="festival-banner"
             v-if="live.festival === 1">
            <img src="../../assets/images/festival_banner.jpg"
                 alt="春节直播">
        </div>
        <section class="header">
            <div class="header-video"
                 :style="isFest"
                 :class="{'fixed-top': isFixedHeader}">
                <div class="mask"
                     v-if="live === null">
                    <div><i class="fa fa-circle-o-notch fa-spin"></i></div>
                    <div>努力加载中...</div>
                </div>
                <Video v-if="live && (live.status === 2 || live.status == 4)"
                       :id="'live-video-' + live.id"
                       :url="live.url"
                       :poster="live.poster"
                       width="100%"
                       :height="live.height"
                       :autoplay="true"
                       :error="errorCallback">
                </Video>
                <div class="mask"
                     v-if="live && !(live.status === 2 || live.status == 4)">
                    <img :src="live.poster" />
                    <div class="info"
                         style="position: absolute;">
                        <div style="height: 48px">
                            <img :src="logo"
                                 style="height: 48px;width: 48px;margin-left: -24px;border-radius: 4px;z-index: 9999;" />
                        </div>
                        <div>直播尚未开始</div>
                        <div>开播时间: {{live.startTime}}</div>
                        <div class="btn"
                             @click="errorCallback"><i class="fa fa-refresh"></i> 立即刷新</div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Video from "../video"
import logo from "../../assets/logo.png"

export default {
    name: "VideoHeader",
    data () {
        return {
            logo: logo,
            width: "100%",
            isFixedHeader: false
        }
    },
    props: {
        live: Object
    },
    components: {
        Video
    },
    computed: {
        isFest () {
            if (this.live.festival === 0) {
                return {
                    width: parseInt(this.live.width) + 'px',
                    height: this.live.height + 'px'
                }
            }
            if (this.live.festival === 1) {
                return {
                    width: this.isFixedHeader ? parseInt(this.live.width) + 'px' : parseInt(this.live.width) - 20 + 'px',
                    height: this.live.height + 'px',
                    padding: this.isFixedHeader ? 0 : '0 0.26rem',
                    background: 'linear-gradient(#df352f, #fff)'
                }
            }
        }
    },
    mounted () {
        this.$nextTick(() => {
            window.addEventListener("scroll", () => {
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                this.isFixedHeader = this.live.festival === 1 ? scrollTop > 300 : scrollTop > 0 && this.video !== null
            });
        });
    },
    methods: {
        errorCallback () {
            window.location.reload()
        }
    }
}
</script>

<style scoped>
.display {
    display: none;
}

.mask,
.mask img {
    position: absolute;
    height: 100%;
    width: 100%;
}

.mask img {
    z-index: -1;
}

.mask {
    background-color: #00000090;
}

.mask .info {
    color: #fff;
    text-align: center;
}
.mask .info div {
    height: 20px;
    margin-top: 0.3rem;
}

.mask .info .btn {
    width: 80px;
    padding: 0.1rem 0.6rem;
    border: 1px solid;
    display: inline-block;
}
.festival-banner img {
    width: 100%;
}
</style>
